import React from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { RemovedEventPanelFormFieldsProvider } from '../event-panel/event-panel-form/form-persistence/use-locally-removed-fields';
import { FormHasHadDataSetAtLeastOnceProvider } from '../event-panel/event-state/form-has-had-data-set-at-least-once';
import { FrEventPanelProvider } from './fr-event-panel-provider';
import { useAutoNavigateToMainPageWhenUnassigned } from '../fr-navigation/hooks/use-auto-navigate-to-main-page-when-unassigned';

export function FrEventRootProviders() {
    const params = useParams();
    const paramsEventId = params.eventId ? Number(params.eventId) : undefined;

    useAutoNavigateToMainPageWhenUnassigned();

    return (
        <FormHasHadDataSetAtLeastOnceProvider>
            <RemovedEventPanelFormFieldsProvider>
                <FrEventPanelProvider key={paramsEventId} eventId={paramsEventId}>
                    <Outlet />
                </FrEventPanelProvider>
            </RemovedEventPanelFormFieldsProvider>
        </FormHasHadDataSetAtLeastOnceProvider>
    );
}
